import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, colores, funciones } from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Table, TableFixedColumns, TableInlineCellEditing} from '@devexpress/dx-react-grid-material-ui';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';
import Input from '@material-ui/core/Input';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const styles = theme => ({
 
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
container: {
  display: 'flex',
  justifyContent: !movil ? 'center' : undefined, 
  alignItems: "center",
  flexDirection: !movil ? "row" : "column",
  paddingTop: "2px",
  paddingBottom: "5px", 
  paddingLeft: !movil ? theme.spacing(4) : theme.spacing(1),
  paddingRight: !movil ? theme.spacing(4) : theme.spacing(1), 
}
});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns =  [  
  { name: 'CUENTA_ALUMNO', title: 'Cuenta'},
  { name: 'NOMBRE_COMPLETO', title: 'Nombre completo'},
  { name: 'VALOR_I', title: 'I'},
  { name: 'VALOR_II', title: 'II'},
  { name: 'VALOR_III', title: 'III'},
  { name: 'VALOR_IV', title: 'IV'},
  { name: 'VALOR_EXTRA', title: 'Extra'},
  { name: 'VALOR_LAB', title: 'Lab'},
  { name: 'TOTAL', title: 'Total (100)'},
  { name: 'MODALIDAD', title: 'Modalidad'},
];
const columnExtensions = [
  { columnName: 'CUENTA_ALUMNO', width: widthTable * 0.09 },
  { columnName: 'NOMBRE_COMPLETO', width: widthTable * 0.30 },
  { columnName: 'VALOR_I', width: widthTable * 0.07, align: 'center'},
  { columnName: 'VALOR_II', width: widthTable * 0.07, align: 'center'},
  { columnName: 'VALOR_III', width: widthTable * 0.07, align: 'center'},
  { columnName: 'VALOR_IV', width: widthTable * 0.07, align: 'center'},
  { columnName: 'VALOR_EXTRA', width: widthTable * 0.07, align: 'center'},
  { columnName: 'VALOR_LAB', width: 0, align: 'center'},               
  { columnName: 'TOTAL', width: widthTable * 0.07, align: 'center'},  
];
const grouping = [{ columnName: "MODALIDAD" }];

const RowId = row => row.CUENTA_ALUMNO;
const RenderOption = (option) => (
  <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.2, width: "100%" }}>                                     
    <div style={{ display: "flex", width: "100%", flexDirection: "row", fontSize: 11 }}>
     <div style={{ width: "40%", color: "gray" }}>{"Sección " + option.NUMERO_SECCION}</div>
     <div style={{ width: "60%", textAlign: "right", color: colores.color_disabled, fontStyle: "italic" }}>{"Jornada " + option.JORNADA}</div> 
    </div>
    {option.DESCRIPCION}                                    
  </div>
);
const GroupCellContent = ({ column, row }) => { 
  return(<strong>{row.value}</strong>);
}
const VirtualTable_cellComponent = (calExt)=> ({onClick, ...props}) => {  
  
  const color = undefined;
  const color_inactivo = "#C8C8C8";
  const color_ext = colores.azul;
  const color_ext_inactivo = "#add8e6";
  const calExtCol = calExt(null, props.row);

  const style = {cursor: "text", 
                 color: props.column.name === 'VALOR_EXTRA' ? calExtCol === null ? color_ext : color 
                       : 
                       calExtCol === props.column.name ? color_ext : color
                }
  
  if (props.column.name === 'TOTAL')
  { 
    let total = parseInt(props.row.VALOR_I) + parseInt(props.row.VALOR_II) + parseInt(props.row.VALOR_III) + parseInt(props.row.VALOR_IV) + (props.row.VALOR_LAB !== null ? parseInt(props.row.VALOR_LAB) : 0);
            
    if (parseInt(props.row.VALOR_EXTRA) > 0){
      total = calExt(total, props.row);
    }

    return (<Table.Cell style={{ fontWeight: "bold" }} {...props}>
            {String(total)}
            </Table.Cell>);
  }
  
  const styleNota = { color: calExtCol === props.column.name ? color_ext_inactivo : color_inactivo }

  if (props.column.name === 'CUENTA_ALUMNO' || props.column.name === 'NOMBRE_COMPLETO')
    return (<Table.Cell {...props}/>);

  if (props.column.name === 'VALOR_LAB')
    return (<Table.Cell style={{ color: color_inactivo }} {...props}/>);

  if (props.column.name === 'VALOR_I' && (!Boolean(props.row.ACTIVA_I) || Boolean(props.row.TIENE_MORA) || Boolean(props.row.APLICADA)))
    return (<Table.Cell style={styleNota} {...props}/>);

  if (props.column.name === 'VALOR_II' && (!Boolean(props.row.ACTIVA_II) || Boolean(props.row.TIENE_MORA) || Boolean(props.row.APLICADA)))
    return (<Table.Cell style={styleNota} {...props}/>);

  if (props.column.name === 'VALOR_III' && (!Boolean(props.row.ACTIVA_III) || Boolean(props.row.TIENE_MORA) || Boolean(props.row.APLICADA)))
    return (<Table.Cell style={styleNota} {...props}/>);
  
  if (props.column.name === 'VALOR_IV' && (!Boolean(props.row.ACTIVA_IV) || Boolean(props.row.TIENE_MORA) || Boolean(props.row.APLICADA))) 
    return (<Table.Cell style={styleNota} {...props}/>);
  
  if (props.column.name === 'VALOR_EXTRA' && (!Boolean(props.row.ACTIVA_EXTRA) || Boolean(props.row.TIENE_MORA) || Boolean(props.row.APLICADA))) 
    return (<Table.Cell style={{color: calExtCol === null ? color_ext_inactivo : color_inactivo, cursor: "default" }} {...props}/>);

  
  return (<Table.Cell onClick={onClick} style={style} {...props}/>);
    
}
const cellsEditingCellComponent = ({value, onValueChange, ...props}) =>{
  
  const style= { padding: "0px 25px" } 
  
  const handleChange = (event) => { 
    onValueChange(event.target.value);
  }
  const onKeyPress = (ev) =>
  {  
    const key = ev.key;
                
    if (isNaN(parseInt(key)))
    {
      ev.preventDefault();
      return false;
    }

    return true;
  }

  return (<TableInlineCellEditing.Cell style={style} {...props}>
           <Input defaultValue={value}
                  fullWidth 
                  onChange={handleChange}
                  inputProps={{ maxLength: 3, style: { textAlign: "center" }, inputMode: movil ? "numeric" : undefined }}
                  onKeyPress={onKeyPress}/>
          </ TableInlineCellEditing.Cell>);

}
const TableRow = ({ highlighted, rowIndex, row, selectByRowClick, ...props}) => {
        
  const odd = !!(rowIndex % 2);      
                                  
  return (
         <Table.Row {...props}               
          style={{
             backgroundColor: odd ? colores.tabla.alternateColorRow1 : colores.tabla.alternateColorRow2,      
           }}

         />
       );

}
const ColumnFixed_cellComponent = ({showRightDivider, showLeftDivider, ...props}) => { 
    
  if (props.tableRow.key === "Symbol(filter)"){
    return (<TableFixedColumns.Cell showRightDivider={false} {...props}>
              <div style={{ background: "inherit", height: "30px", width: "100%" }} />
             </TableFixedColumns.Cell>);
  }

  return (<TableFixedColumns.Cell
              showRightDivider={false}
              showLeftDivider={false}
              style={{ backgroundColor: "inherit" }}
              {...props} 
          />);
} 

export default withStyles(styles) ( 
class App extends React.Component {

tablaRef = React.createRef();

  constructor (props) {
    super(props);
    this.l=props.l
    this.e=props.e
    this.i=props.i
    this.state = {
       isLoggin : undefined,
       heightTableMain: 0,
       loadingMain: false,
       rows: [],
       optionsSecciones: [],
       valueSeccion: null,
       loadingSecciones: true,
       columns,
       columnExtensions,
       expandedGroups: [],
   };
   this.settingFilter = [
    { columnName: 'TOTAL',
       predicate: (value, filter, row) => {
        let total = parseInt(row.VALOR_I) + parseInt(row.VALOR_II) + parseInt(row.VALOR_III) + parseInt(row.VALOR_IV) + (row.VALOR_LAB !== null ? parseInt(row.VALOR_LAB) : 0);
        value = parseInt(row.VALOR_EXTRA) > 0 ? this.calExt(total, row) : total;
       return IntegratedFiltering.defaultPredicate(value, filter, row);
      },
    },
   ];
}

obtener_secciones = ()=>{

new Request
 .get(`${globales.ip}/calificador/secciones/${tokenInfo.user}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
          
     if (err) { 
  
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
              
        window.location.reload();
        return;
                
       }
  
       this.setState({ loadingSecciones: false }, ()=>{ 
         funciones.showToast('e', 'No hay conexión'); 
       }); 
                  
       return;
     }
        
   const rows = JSON.parse(res.text);
  
   this.setState({ optionsSecciones: rows, 
                   loadingSecciones: false });    
                        
});

}

obtener_listado = (id_seccion)=>{
  
  new Request
  .get(`${globales.ip}/calificador/listado/${id_seccion}/${tokenInfo.user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
              
        window.location.reload();
        return;
                
       }
  
       this.setState({ loadingMain: false }, ()=>{ 
         this.setTitulos(null);
         funciones.showToast('e', 'No hay conexión'); 
       }); 
                  
       return;
     }
        
   const rows = JSON.parse(res.text);

   let expandedGroups = [];
   rows.map((item)=>{
    if (!expandedGroups.find(x => x === item.MODALIDAD))
     expandedGroups.push(item.MODALIDAD);

     return item;
   });

   if (rows.length > 0){
    const {columnExtensions} = this.state;
    if (rows[0].LAB === null && columnExtensions.find(x => x.columnName === "VALOR_LAB").width !== 0)
      this.setColumnaLab(false);
    else if (rows[0].LAB !== null && columnExtensions.find(x => x.columnName === "VALOR_LAB").width === 0)
      this.setColumnaLab(true);

    this.setTitulos(rows[0]);
   }

   this.setState({ rows, 
                   expandedGroups,
                   loadingMain: false });                
     
});

}

onChangeAutocomplete = (event, newValue)=>{

this.setState({ rows: [],
                expandedGroups: [],
                valueSeccion: newValue }, ()=>{

  if (newValue === null)
    return;

  this.setState({ loadingMain: true }, ()=>{
    this.obtener_listado(newValue.ID_SECCION);
  });  
  
});
 
}

setColumnaLab = (visibleLab)=>{ 

  const columnExtensions = this.state.columnExtensions.map((item)=> {
    if (item.columnName === "VALOR_LAB")
      item.width = visibleLab ? widthTable * 0.08 : 0;

    return item;
  });

  this.setState({ columnExtensions });

}

changeExpandedGroups = expandedGroups =>{
  this.setState({ expandedGroups });
}

setTitulos = (row)=>{

const columns = this.state.columns.map((item)=> {
  if (item.name === "VALOR_I")
   item.title = row !== null ? "I (" + row.POND_1 + ")" : "I";

  if (item.name === "VALOR_II")
   item.title = row !== null ? "II (" + row.POND_2 + ")" : "II";

  if (item.name === "VALOR_III")
   item.title = row !== null ? "III (" + row.POND_3 + ")" : "III";

  if (item.name === "VALOR_IV")
   item.title = row !== null ? "IV (" + row.POND_4 + ")" : "IV";

  if (item.name === "VALOR_EXTRA")
   item.title = row !== null ? "Extra (" + row.POND_5 + ")" : "Extra";

  if (item.name === "VALOR_LAB")
   item.title = row !== null ? "Lab (" + row.POND_6 + ")" : "Lab";

  return item;
 });

 this.setState({ columns });

}

commitChanges = ({ changed }) => { 
  
  const tmpValue = Object.values(changed);
  const cuenta = Object.keys(changed)[0];
  
  if (tmpValue[0] === undefined)
   return;

  const colName = Object.keys(tmpValue[0])[0]; 
  const newValue = Object.values(tmpValue[0])[0]; 
  
  if (isNaN(newValue) || funciones.isEmpty(newValue)){
    funciones.showToast("w", "El valor es incorrecto");
    return;
  }
  
  const row = this.state.rows.find(x => x.CUENTA_ALUMNO === cuenta); 
  const maxPond = colName === "VALOR_I" ? row.POND_1 : 
                  colName === "VALOR_II" ? row.POND_2 :
                  colName === "VALOR_III" ? row.POND_3 :
                  colName === "VALOR_IV" ? row.POND_4 : row.POND_5;
  
  if (parseInt(newValue) > parseInt(maxPond) || parseInt(newValue) < 0){
    funciones.showToast("w", "El valor debe estar entre 0 y " + maxPond);
    return;
  }

  const old_rows = this.state.rows;

  changed[cuenta][colName] = parseInt(newValue);
  const changedRows = this.state.rows.map(row => (changed[row.CUENTA_ALUMNO] ? { ...row, ...changed[row.CUENTA_ALUMNO] } : row));
  this.setState({ rows: changedRows }, ()=>{

    this.setState({ loadingSecciones: true }, ()=>{

      const id_calificacion = colName === "VALOR_I" ? row.I : 
                              colName === "VALOR_II" ? row.II :
                              colName === "VALOR_III" ? row.III :
                              colName === "VALOR_IV" ? row.IV : row.EXTRA;

        this.actualizar_nota(id_calificacion, newValue, old_rows);
    });

  });

}

calExt = (total, row)=>{
    let minNota = 100;
    let extNota = 0;
    let parcialExt = null;
  
    if (Boolean(row.PERMITE_EXTRA_I) && parseInt(row.VALOR_I) < minNota ){
      minNota = row.VALOR_I;
      parcialExt  = "VALOR_I";
      extNota = parseInt(row.VALOR_EXTRA);
      //&& parseInt(row.VALOR_EXTRA) > parseInt(row.VALOR_I)
    } 
     
    if (Boolean(row.PERMITE_EXTRA_II) && parseInt(row.VALOR_II) < minNota){
      minNota = parseInt(row.VALOR_II);
      parcialExt = "VALOR_II";
      extNota = parseInt(row.VALOR_EXTRA); 
      // && parseInt(row.VALOR_EXTRA) > parseInt(row.VALOR_II)
    } 
  
    if (Boolean(row.PERMITE_EXTRA_III) && parseInt(row.VALOR_III) < minNota ){
      minNota = parseInt(row.VALOR_III);
      parcialExt = "VALOR_III";
      extNota = parseInt(row.VALOR_EXTRA);
      //&& parseInt(row.VALOR_EXTRA) > parseInt(row.VALOR_III)
    } 
  
    if (Boolean(row.PERMITE_EXTRA_IV) && parseInt(row.VALOR_IV) < minNota ){
      minNota = parseInt(row.VALOR_IV);
      parcialExt = "VALOR_IV";
      extNota = parseInt(row.VALOR_EXTRA);
      //&& parseInt(row.VALOR_EXTRA) > parseInt(row.VALOR_IV)
    }
    
    if (total === null)
     return parcialExt;
  
    return total - (minNota !== 100 ? minNota : 0) + extNota ;
    
  }

actualizar_nota=(id_calificacion, valor, old_rows)=>{
 
  new Request
  .post(`${globales.ip}/calificador`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .set('Content-Type', 'application/json')
  .send({ id_calificacion, 
          valor, 
          ad_usuario: tokenInfo.user })
  .retry(0)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
        
        this.setState({ rows: old_rows, loadingSecciones: false }, ()=> { 
          funciones.showToast('e', 'No hay conexión'); 
        });
              
        return;
     }
        
     const rows = JSON.parse(res.text);

     this.setState({ loadingSecciones: false }, ()=>{

      if (rows[0].RESP !== 'OK')
       this.setState({ rows: old_rows }, ()=>{
         funciones.showToast("w", rows[0].RESP);
       });

     });       

});

}

componentDidMount() { //Load

 tokenInfo = Auth.getProfile(); //Token decodificado

 this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{

  if (tokenInfo.plataforma === 3)
  {
     this.obtener_secciones();
     this.setColumnaLab(false);      
  }
     
  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }); 

 }); 


              
}


render() {
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 3)
            {
              
              return (
                <React.Fragment>
                 <div className={classes.container}>    
                  <Autocomplete
                    id="secciones"
                    options={this.state.optionsSecciones}
                    getOptionLabel={(option) => option.DESCRIPCION_CURSO + ' (' + option.NUMERO_SECCION + ')'}
                    style={{ width: !movil ? '430px' : '100%' }}
                    renderInput={(params) => <TextField {...params} 
                                                        label="Curso"
                                                        variant="outlined"                                                                                                                                                                                    
                                                        InputProps={{
                                                              ...params.InputProps,
                                                              endAdornment: (
                                                                <React.Fragment>
                                                                  {this.state.loadingSecciones ? <CircularProgress size={18} /> : null}
                                                                  {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                              ),
                                                            }}
                                                            fullWidth
                                                            />}
                     renderOption={RenderOption}                                  
                     onChange={this.onChangeAutocomplete}                                  
                     loading={this.state.loadingSecciones}
                     value={this.state.valueSeccion}
                     PaperComponent={(props)=>(<Paper elevation={8} {...props} />)}                                                                 
                    />
                 </div>
                 <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions">
                 <CustomTable 
                   Columns={this.state.columns} 
                   Rows={this.state.rows}
                   Grouping={grouping}                      
                   TableColumnExtensions={this.state.columnExtensions}
                   ExpandedGroups={this.state.expandedGroups}
                   ChangeExpandedGroups={this.changeExpandedGroups}
                   groupContentComponent={GroupCellContent}     
                   getRowId={RowId}
                   VirtualTable_cellComponent={VirtualTable_cellComponent(this.calExt)}
                   height={this.state.heightTableMain} 
                   loading={this.state.loadingMain} 
                   RowComponent={TableRow}
                   enabledFilterRows
                   FilteringColumnExtensions={this.settingFilter} 
                   cellsEditing
                   commitChanges={this.commitChanges}
                   cellsEditingCellComponent={cellsEditingCellComponent}
                   selectTextOnEditStart 
                   leftColumnsFixed={['CUENTA_ALUMNO']}
                   columnFixedCellComponent = {ColumnFixed_cellComponent}           
                  />                  
                </div>
                
                <Backdrop open={this.state.loadingSecciones || this.state.loadingMain}
                            className={classes.backdrop} 
                            invisible 
                            transitionDuration={0}/>

                </React.Fragment>
              );

             }             
             
            })()

          }

        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)